import { createReducer } from '@reduxjs/toolkit';
import { RequestState } from 'modules/types/common';
import { switchAccountSuccess } from 'store/account/actions';
import { setFetchingFailState, setFetchingState } from 'store/setLocalStore';
import * as actions from './actions';
import { GoalsState } from './types';

const initialState: GoalsState = {
  isFetching: false,
  error: null,
  data: [],
  requestState: RequestState.INITIALIZED,
  lastUpdated: undefined
};

const GoalsReducer = createReducer(initialState, {
  [actions.GET_GOALS]: (state, action) => {
    setFetchingState(state, action);
    state.requestState = RequestState.REQUESTING;
  },
  [actions.GET_GOALS_FAIL]: (state, action) => {
    setFetchingFailState(state, action);
    state.requestState = RequestState.ERROR;
  },
  [actions.GET_GOALS_SUCCESS]: (state, action) => {
    state.isFetching = false;
    state.data = action.payload.data;
    state.requestState = RequestState.SUCCESS;
  },
  [actions.GET_GOALS_CACHE_SUCCESS]: (state, action) => {
    state.data = action.payload.data;
    state.lastUpdated = action.payload.cacheUpdatedAt;
  },
  [switchAccountSuccess.type]: () => initialState
});

export default GoalsReducer;
